import constants from 'constants/index'

const format = (id) => {
  return (
    (id && constants.cardFlag.CARD_FLAG_FORMAT_VALIDATION[id]) ||
    constants.cardFlag.DEFAULT_FORMAT
  )
}

export default format
